import { IconContext } from "react-icons"
import PopupBackground from "../popup-background"

import { FaCheck } from "react-icons/fa"
export default function PopupSendOrderSuccess(props: { visibility: boolean }) {
  return (
    <PopupBackground visibility={props.visibility} id={""}>
      <div className="flex flex-row items-center w-fit bg-white rounded-2xl border border-[#E6E6E6] px-10 py-10 gap-x-5">
        <IconContext.Provider value={{ className: "w-7 h-7 md:w-9 md:h-9" }}>
          <FaCheck color="#15803d" />
        </IconContext.Provider>

        <h1 className="text-lg font-semibold text-center text-green-700 md:text-2xl">
          Vaše objednávka byla odeslána ke zpracování
        </h1>
      </div>
    </PopupBackground>
  )
}
